
const API_CONFIG = {
  BASE_URL: process.env.REACT_APP_API_URL || 'http://localhost',
  PORT: process.env.REACT_APP_API_PORT || '4000',
  
  getFullUrl: function() {
	  if(this.PORT==='80'){
		  return `${this.BASE_URL}`;
	  }else{
		 return `${this.BASE_URL}:${this.PORT}`; 
	  }		  
  },
};

export const buildApiUrl = (endpoint) => {
  return `${API_CONFIG.getFullUrl()}${endpoint}`;
};

export const getBaseUrl = () => {
  return API_CONFIG.getFullUrl();
};

export const getBaseUrlWithoutPort = () => {
  return API_CONFIG.BASE_URL;
};

export const getPort = () => {
  return API_CONFIG.PORT;
};

export default API_CONFIG; 